<template>
  <div class="container">
    <div class="account-box" style="position: absolute; top: 50%; margin-top: -75px; left: 50%; margin-left: -240px">
      <!-- LOGIN FORM -->
      <div class="account-wrapper">
        <h3 class="account-title">Benefits Connect</h3>
        <hr />
        <div class="text-center" v-html="message"></div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../../http-common.js";

export default {
    data() {
        return {
            message: "Connecting..."
        };
    },
  methods: {
    login() {
        if ( this.$route.query.session ) {
            this.message = "Expired session.<br>Please access Benefits Connect from Ignite.";
        }
        else if ( !this.$route.query.token ) {
            this.message = "Unauthorized access";
        }
        else {
            API.ssologin({ Token: this.$route.query.token })
            .then((response) => {
            this.$store.state.isLoading = false;
            let success = response.data.success;
            if (success) {
                localStorage.setItem(
                "lambitoken",
                JSON.stringify(response.data.data)
                );

                localStorage.setItem("lamsso", true);
                this.$router.replace({ name: "home" });
            } else {
                this.message = response.data.message;
            }
            })
            .catch((error) => {
                this.message = error;
            });
        }
    },
    
  },

    created() {
        this.login();
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Account/SSO.vue